// extracted by mini-css-extract-plugin
module.exports = {"adminBoardSettingsGeneral":"WkPex6G+","namingFields":"TsJxJ4SE","description":"qj7yavGq","row":"qdcNd5vW","error":"nLLDukNv","button":"KDagcJ4e"};